export default "__VITE_ASSET__b8c75986__"